export const appGoogleDriveGrayIcon = {
    data: `<svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.963 13.8889L14.8519 5H9.81485L14.926 13.8889H19.963ZM10.6297 14.6296L8.11114 19.0741H17.8148L20.3334 14.6296H10.6297ZM9.14818 6.11111L4.33337 14.6296L6.85189 19.0741L11.7408 10.5556L9.14818 6.11111Z" fill="#4F4F4F"/></svg>`,
    name: 'google-drive-gray'
};